'use client';

import { useEffect } from 'react';
import { SharedRecorder } from '@/lib/recording/SharedRecorder';

// Extend Window interface to include our SharedRecorder
declare global {
  interface Window {
    sharedRecorder: SharedRecorder;
  }
}

/**
 * Component that initializes the SharedRecorder singleton and makes it globally available
 * via the window object. This runs once when the app starts.
 */
export default function SharedRecorderInitializer() {
  useEffect(() => {
    // Make SharedRecorder instance available globally
    if (typeof window !== 'undefined') {
      window.sharedRecorder = SharedRecorder.getInstance();
    }
  }, []);

  // This component doesn't render anything
  return null;
}